module.exports = __webpack_public_path__ + "img/login-logo.57a50e88.png";